import Swiper from 'swiper/bundle'

const $ = jQuery

export default function FeaturesOverview () {
  const WRAPPERS = document.querySelectorAll('.mtt-features-overview')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const featuresClass = new FeaturesOverviewClass(WRAPPERS[i])
      featuresClass.init()
    }
  }
}

class FeaturesOverviewClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.SWIPER_PAGINATION = this.WRAPPER.querySelector('.swiper-pagination')
    this.SWIPER_CONTAINER = this.WRAPPER.querySelector('.swiper-container')
  }

  init () {
    this.createSwiper()
  }

  createSwiper () {
    if (!this.SWIPER_CONTAINER || !this.SWIPER_PAGINATION) return

    let bulletData = this.SWIPER_PAGINATION.getAttribute('data-bullets')
    bulletData = JSON.parse(bulletData)

    const SWIPER = new Swiper(this.SWIPER_CONTAINER, {
      init: false,
      slidesPerView: 1,
      speed: 800,
      spaceBetween: 24,
      autoHeight: true,
      watchOverflow: true,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.SWIPER_PAGINATION,
        type: 'bullets',
        clickable: true,
        renderBullet: (i, cls) => {
          return `<div class="${cls}"><span>${bulletData[i].title}</span></div>`
        }
      }
    })

    SWIPER.on('slideChange', () => this.scrollTo())

    SWIPER.init()
  }

  scrollTo () {
    if (this.getScreenWidth() <= 900) {
      const _this = this
      $('html, body').animate({
        scrollTop: $(this.SWIPER_CONTAINER).offset().top - _this.getHeaderHeight()
      }, 800)
    }
  }

  getHeaderHeight () {
    let height = 0
    const HEADER = document.getElementById('main_header')
    HEADER && (height += HEADER.getBoundingClientRect().height)
    const ADMIN_BAR = document.getElementById('wpadminbar')
    ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
    return height
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
